import { toteValidate } from "../../application/dtos/tote_validate";

export class toteEntity {
    constructor({id, name, shipment_id, shipment_type, slot_id, slot, warehouse_id, warehouse}){
        this.id = id;
        this.name = name;
        this.shipment_id = shipment_id;
        this.shipment_type = shipment_type;
        this.slot_id = slot_id
        this.slot = slot;
        this.warehouse_id = warehouse_id;
        this.warehouse = warehouse;
    }

    isValid() {
        return toteValidate(this);
    }
}